import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { UserPublicProfile } from '@user/PublicProfile';
import { AnonymousUserNameChange } from '../AnonymousUserNameChange';
import { MenuButton } from './MenuButton';
import { MenuLink } from './MenuLink';
import { NameLabel } from './NameLabel';

type Props = {
  profile: UserPublicProfile;
  onLogout(): void;
};

/**
 * 匿名ユーザ向けのポップアップメニュー
 */
export const AnonymousUserPopupMenu: React.FC<Props> = ({ profile, onLogout }: Props) => {
  const { t } = useTranslation();
  // ユーザ編集モーダルの表示制御
  const [showEditUserModal, setEditUserModal] = useState<boolean>(false);
  const handleOpenEditUserModal = useCallback(() => setEditUserModal(true), []);
  const handleCloseEditUserModal = useCallback(() => setEditUserModal(false), []);

  return (
    <>
      {/* アイコン+名前 */}
      <NameLabel
        name={profile.name}
        userId={profile.id}
        imageUrl={profile.imageUrl}
        isAnonymous={profile.isAnonymous}
      />

      <MenuLink href="https://balus-help.levii.co.jp/" label={t('framework.topNav.help')} />

      <MenuButton onClick={handleOpenEditUserModal}>{t('framework.topNav.changeName')}</MenuButton>
      {showEditUserModal && <AnonymousUserNameChange currentName={profile.name} onClose={handleCloseEditUserModal} />}

      <MenuButton onClick={onLogout}>{t('framework.topNav.logout')}</MenuButton>
    </>
  );
};
